import { useUpdateUserLanguageMutation } from "@workspace/casino_core/mutations/UpdateUserLanguageMutation.client";

const useUpdateUserLanguage = () => {
  const [update] = useUpdateUserLanguageMutation();
  const updateUserLanguage = async (language: LanguageCode) =>
    update({ input: { language } });
  return updateUserLanguage;
};

export default useUpdateUserLanguage;
